import { useTranslation } from "react-i18next"
import { Button, Form, Row } from 'react-bootstrap'
import { useEffect, useState } from "react"
import Select from "react-select"
import customStyles from "../../../components/design/select"

export default function FormFarm({submit, isNew, inputChange, state, origens}) {
    const { t } = useTranslation()

    const [origensOptions, setOrigensOptions] = useState([])
    const [farmOrigens, setOrigen] = useState('')

    const handleSelectOrigensChange = (e) => {
        inputChange({target:{name: 'origen', value: e.value}})
    }

    useEffect(()=>{
        let origensAvailable = []
        let origensSelected = []
        
        origens?.forEach(origen => {
            if(origen.type === false){
                let object = {value: origen._id, label: origen.name}
                origensAvailable.push(object)
                if (state.origen && state.origen.indexOf(origen._id) !== -1) {
                    origensSelected.push(origensAvailable[origensAvailable.length - 1])
                }
            }
        })
        setOrigensOptions(origensAvailable)
        setOrigen(origensSelected)
    },[state, origens])

    return (
        <>
            <Form onSubmit={submit}>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('farms.name')}</Form.Label>
                    <Form.Control className="form-control"
                        type='text'
                        name='name' 
                        value={state.name || state.nameEdit ||  ''}
                        placeholder={t('farms.name')}
                        onChange={inputChange}
                        required
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('farms.latitude')}</Form.Label>
                    <Form.Control className="form-control"
                        type='text'
                        name='latitude' 
                        value={state.latitude || state.latitudeEdit ||  ''}
                        placeholder={t('farms.latitude')}
                        onChange={inputChange}
                        required
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('farms.longitude')}</Form.Label>
                    <Form.Control className="form-control"
                        type='text'
                        name='longitude' 
                        value={state.longitude || state.longitudeEdit ||  ''}
                        placeholder={t('farms.longitude')}
                        onChange={inputChange}
                        required
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('farms.origen')}</Form.Label>
                    <Select onChange={handleSelectOrigensChange}
                        name="origen" 
                        placeholder={t('farms.origen')}
                        options={origensOptions}
                        value={farmOrigens}
                        styles={customStyles}
                        required/>
                </Form.Group>
                <Row className="text-left custom-card-header-list">
                    {
                        isNew === false
                        ?
                        <Button className="btn btn-secondary my-2 mx-auto" type="submit"><i className="fas fa-save"></i> {t('farms.update')}</Button>
                        :
                        <Button className="btn btn-secondary my-2 mx-auto" type="submit"><i className="fas fa-save"></i> {t('farms.new')}</Button>
                    }
                </Row>
            </Form>
        </>
    )    
}
